import { IPayloadWrapper } from "./PayloadWrapper";
import { IErrorModel } from "../../interfaces/Error/IErrorModel";

export const SET_APP_MODE = "automatpacken/applicationState/SET_APP_MODE";
export const SET_NEXT_ACTION = "automatpacken/applicationState/SET_NEXT_ACTION";
export const SET_LOADING = "automatpacken/applicationState/SET_LOADING";
export const SET_SHOW_LOADER = "automatpacken/applicationState/SET_SHOW_LOADER";
export const SET_ERROR = "automatpacken/applicationState/SET_ERROR";
export const CLEAR_ERROR = "automatpacken/applicationState/CLEAR_ERROR";
export const SET_WAS_CANCELLED = "automatpacken/applicationState/SET_WAS_CANCELLED";
export const SET_FORCE_SHELF = "automatpacken/applicationState/SET_FORCE_SHELF";
export const CLEAR_APP_STATE = "automatpacken/applicationState/CLEAR_APP_STATE";
export const SET_LOGIN_STATUS = "automatpacken/applicationState/SET_LOGIN_STATUS";
export const SET_PACKING_ALLOWED = "automatpacken/applicationState/SET_PACKING_ALLOWED";
export const SET_PERSISTED_CART_ID = "automatpacken/applicationState/SET_PERSISTED_CART_ID";
export const SET_PERSISTED_SORT_ID = "automatpacken/applicationState/SET_PERSISTED_SORT_ID";
export const SET_DISPATCH_TIMESTAMP = "automatpacken/applicationState/SET_DISPATCH_TIMESTAMP";
export const SET_SHOULD_REDIRECT = "automatpacken/applicationState/SET_SHOULD_REDIRECT";
export const SET_IS_BETA_WORKSTATION = "automatpacken/applicationState/SET_IS_BETA_WORKSTATION";
export const SET_BURNED_ORDERS_MUST_BE_PACKED_FIRST =
  "automatpacken/applicationState/SET_BURNED_ORDERS_MUST_BE_PACKED_FIRST";
export const SET_CONVEYOR_ID = "automatpacken/applicationState/SET_CONVEYOR_ID";
export const SET_IS_SCAN_ID_VALIDATION_RX_REQUIRED =
  "automatpacken/applicationState/SET_IS_SCAN_ID_VALIDATION_RX_REQUIRED";
export const SET_IS_SCAN_ID_VALIDATION_REMOVE_SKU_REQUIRED =
  "automatpacken/applicationState/SET_IS_SCAN_ID_VALIDATION_REMOVE_SKU_REQUIRED";
export const SET_IS_SCAN_ID_VALIDATION_CANCEL_SORTBOX_REQUIRED =
  "automatpacken/applicationState/SET_IS_SCAN_ID_VALIDATION_CANCEL_SORTBOX_REQUIRED";

interface SetAppMode {
  type: typeof SET_APP_MODE;
  payload: IPayloadWrapper<number>;
}

interface SetShouldRedirect {
  type: typeof SET_SHOULD_REDIRECT;
  payload: IPayloadWrapper<boolean>;
}

interface SetNextAction {
  type: typeof SET_NEXT_ACTION;
  payload: IPayloadWrapper<number>;
}

interface SetLoadingStatus {
  type: typeof SET_LOADING;
  payload: IPayloadWrapper<boolean>;
}

interface SetShowLoader {
  type: typeof SET_SHOW_LOADER;
  payload: IPayloadWrapper<boolean>;
}

interface SetError {
  type: typeof SET_ERROR;
  payload: IErrorModel;
}

interface ClearError {
  type: typeof CLEAR_ERROR;
}

interface SetWasCancelled {
  type: typeof SET_WAS_CANCELLED;
  payload: IPayloadWrapper<boolean>;
}

interface SetForceShelf {
  type: typeof SET_FORCE_SHELF;
  payload: IPayloadWrapper<number>;
}

interface ClearAppState {
  type: typeof CLEAR_APP_STATE;
}

interface SetLoginStatus {
  type: typeof SET_LOGIN_STATUS;
  payload: IPayloadWrapper<boolean>;
}

interface SetPackingAllowed {
  type: typeof SET_PACKING_ALLOWED;
  payload: IPayloadWrapper<boolean>;
}

interface SetPersistetCartID {
  type: typeof SET_PERSISTED_CART_ID;
  payload: IPayloadWrapper<number>;
}

interface SetPersistetSortID {
  type: typeof SET_PERSISTED_SORT_ID;
  payload: IPayloadWrapper<number>;
}

interface SetLatestDispatchTimestamp {
  type: typeof SET_DISPATCH_TIMESTAMP;
  payload: IPayloadWrapper<number>;
}

interface SetIsBetaWorkstation {
  type: typeof SET_IS_BETA_WORKSTATION;
  payload: IPayloadWrapper<boolean>;
}

interface SetBurnedOrdersMustBePackedFirst {
  type: typeof SET_BURNED_ORDERS_MUST_BE_PACKED_FIRST;
  payload: IPayloadWrapper<boolean>;
}

interface SetConveyorID {
  type: typeof SET_CONVEYOR_ID;
  payload: IPayloadWrapper<string>;
}

interface SetIsScanIdValidationRxRequired {
  type: typeof SET_IS_SCAN_ID_VALIDATION_RX_REQUIRED;
  payload: IPayloadWrapper<boolean>;
}

interface SetIsScanIdValidationRemoveSkuRequired {
  type: typeof SET_IS_SCAN_ID_VALIDATION_REMOVE_SKU_REQUIRED;
  payload: IPayloadWrapper<boolean>;
}

interface SetIsScanIdValidationCancelSortboxRequired {
  type: typeof SET_IS_SCAN_ID_VALIDATION_CANCEL_SORTBOX_REQUIRED;
  payload: IPayloadWrapper<boolean>;
}

export interface ApplicationState {
  nextAction: number;
  loading: boolean;
  showLoader: boolean;
  error: boolean;
  visible: boolean;
  errorMessage: string;
  errorType: number;
  wasCancelled: boolean;
  forceShelf: number;
  loggedIn: boolean;
  appMode: ApplicationMode;
  latestDispatch: number;
  shouldRedirect: boolean;
  isBetaWorkstation: boolean;
  burnedOrdersMustBePackedFirst: boolean;
  conveyorID: string;
  isScanIdValidationRxRequired: boolean;
  isScanIdValidationRemoveSkuRequired: boolean;
  isScanIdValidationCancelSortboxRequired: boolean;
  packingAllowed: boolean;
}

export interface PersistedState {
  cartID: number;
  sortID: number;
}

export enum ApplicationMode {
  Undefined = 0,
  PackingMode = 1,
  BoxReviewMode = 2,
  AFrameReviewMode = 4,
  AutoStoreReviewMode = 5,
  RxBoxMode = 8,
}

export type ApplicationStateTypes =
  | ClearError
  | SetLoadingStatus
  | SetError
  | SetAppMode
  | SetNextAction
  | SetShowLoader
  | SetWasCancelled
  | SetForceShelf
  | ClearAppState
  | SetLoginStatus
  | SetPackingAllowed
  | SetLatestDispatchTimestamp
  | SetShouldRedirect
  | SetIsBetaWorkstation
  | SetBurnedOrdersMustBePackedFirst
  | SetConveyorID
  | SetIsScanIdValidationRxRequired
  | SetIsScanIdValidationRemoveSkuRequired
  | SetIsScanIdValidationCancelSortboxRequired;

export type PersistedDataTypes = SetPersistetCartID | SetPersistetSortID;
